<script setup>

import CloseButton from '../components/CloseButton.vue'
import NavButton from '../components/NavButton.vue'
import { store } from "@/store";

</script>
<template>
  <div class="modal-2609 modal__wi">
    <div class="m__content">
      <CloseButton v-on:click="store.closeModal()">Close</CloseButton>
      <p>You will need to collate as much information about your current retirement savings as possible. This may include:</p>
      <ul>
        <li>The estimated value of your Personal Account – You can obtain this by logging into <a href="https://dc.prudentialstaffps.co.uk/my-account" target="_blank">My account</a>;</li>
        <li>The estimated value of any other defined contribution savings you have;</li>
        <li>The estimated annual pension from any defined benefit schemes you have;</li>
        <li>Your State Pension – you can obtain an estimate of this at <a href="https://gov.uk/check-state-pension" target="__blank">https://gov.uk/check-state-pension</a>; and</li>
        <li>Details of any income from other sources (for example your salary if you plan to continue working).</li>
      </ul>
      <p>Ideally these will be the values at your Selected Retirement Age (SRA).</p>
      <div class="nav-bar">
        <NavButton dir=">" class="no-pn" v-on:click="store.formState.modal = false">OK</NavButton>
      </div>
    </div>
  </div>
</template>
